import styled from "styled-components";

import { colorsPalettes } from "@similarweb/styles";

export const StyledFiltersContainer = styled.div`
    align-items: center;
    border-bottom: 1px solid ${colorsPalettes.carbon["100"]};
    background-color: ${colorsPalettes.carbon["0"]};
    border-top-left-radius: 6px;
    border-top-right-radius: 6px;
    box-sizing: border-box;
    display: flex;
    min-height: 56px;
    padding: 12px 24px;
    position: sticky;
    top: 49px;
    z-index: 21;

    & > div:not(:last-child) {
        margin-right: 8px;
    }
`;
